import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import PowerMenuService from 'donor-elf-web/services/power-menu';

export interface ReportActionMenuItem {
  label: string;
  powerMenuLabel?: string; // deaults to label if blank
  svgJar: string;
  route?: string; // if route is present, it transitions to that route. otherwise it calls onClick()
  onClick?: () => void | Promise<void>;
}

interface ComponentArgs {
  menuItems: ReportActionMenuItem[];
  regularSizeButton?: boolean; // default is false
}

export default class ReportActionsComponent extends Component<ComponentArgs> {
  @service declare router: RouterService;
  @service declare powerMenu: PowerMenuService;

  @action
  async handleOnClick(menuItem: ReportActionMenuItem, dropdown: any) {
    if (menuItem.route) {
      this.router.transitionTo(menuItem.route);
    } else if (menuItem.onClick) {
      await Promise.resolve(menuItem.onClick());
    }
    setTimeout(() => {
      dropdown.actions.close();
    });
  }

  @action
  templateDidInsert() {
    this.powerMenu.prependOptionsFn('actions', this.powerMenuOptions);
  }

  @action
  templateWillDestroy() {
    this.powerMenu.removeOptions('actions');
  }

  @action
  powerMenuOptions() {
    return this.args.menuItems.map((item) => {
      return {
        label: `Actions > ${item.powerMenuLabel || item.label}`,
        fn: item.onClick,
      };
    });
  }
}
